import { createFileRoute, useNavigate } from "@tanstack/react-router"
import EmergencyContactsSettings from "@/components/account/emergency-contacts"
import { useUserType } from "@/hooks/use-user-type"

export const Route = createFileRoute("/_authed/account/emergency-contacts")({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  const { isIndividual } = useUserType()

  if (!isIndividual) {
    navigate({ to: "/account/profile" })
    return null
  }

  return <EmergencyContactsSettings />
}
